<template>
  <vue-apex-charts
    ref="brandpinChartBar"
    :height="barChartHeight"
    v-on:update:heightSetting="setHeight"
    :options="chartOptionsBar"
    :series="series"
  />
</template>

<script>
import VueApexCharts from "vue-apexcharts";



export default {
  name: "BrandPinChartBar",
  components: {
    VueApexCharts,
  },
  data() {
    return {
      barChartHeight: 45*21,
      chartOptionsBar: {
        chart: {
          type: "bar",
          background: '#FBFBFB',
          toolbar:{
            show: false
          },
          sparkline:{
            enabled: true
          },
          events: {
            // dataPointSelection: function(event, chartContext, opt) {
            //   console.log('bar selected!!')
            //   console.log(opt.w.globals.labels[opt.dataPointIndex])
            //   // opt.w.globals.dom.baseEl.__vue__.$store.dispatch('callBrandInsightUpper', { selBrand: opt.w.globals.labels[opt.dataPointIndex] })
            // }
            dataPointSelection: (event, chartContext, opt) =>{
              // console.log(opt.w.globals)
              // console.log(this.barChartSubTitle[opt.dataPointIndex])
              if(this.selectedNode == opt.w.globals.labels[opt.dataPointIndex]){
                this.$parent.changeNode('0000')
              }else{
                this.$parent.changeNode(opt.w.globals.labels[opt.dataPointIndex])
              }
            }
          }
        },
        grid:{
          show: true,
          // yaxis:{
          //   lines:{
          //     show: false
          //   }
          // },
        },
        dataLabels: {
          enabled: true,
          fontFamily: "NanumBarunGothic !important",
          textAnchor: 'start',
          style: {
                // colors: ['#5e5873'],
                colors: ['#333'],
              },
          formatter: function (val, opt) {
                return opt.w.globals.labels[opt.dataPointIndex] + ":  " + Math.round(val).toLocaleString()
                // return Math.round(val) + "%"
              },
          offsetX: 0,
          dropShadow: {
            enabled: true
          }
        },
        stroke: {
              width: 1,
              colors: ['#fff']
            },
        xaxis: {
          categories: [],
        },
        yaxis: {
          labels: {
            show: false
          }
        },
        tooltip: {
          shared: true,
          followCursor: true,
          intersect: false,
          x: {
            show: true
          },
          y: {
            formatter(val){
              return val
            },
            title: {
              formatter: function () {
                return ''
              }
            },
          },
        },
        legend: {
          show: false,
          position: "top",
          horizontalAlign: "left",
          offsetX: 0,
          fontSize: "12px",
          fontFamily: "NanumBarunGothic !important",
          itemMargin: {
            horizontal: 5,
            vertical: 5,
          },
        },
        plotOptions: {
          bar: {
                barHeight: '80%',
                distributed: true,
                horizontal: true,
                dataLabels: {
                  position: 'bottom'
                },
              }
        },
        noData: {
          text: '분석중...',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            color: '#1817E7',
            fontSize: '20px',
            fontFamily: "NanumBarunGothicB"
          }
        },
        colors: ['#33b2df', '#546E7A', '#d4526e', '#13d8aa', '#A5978B', '#2b908f', '#f9a3a4', '#90ee7e',
              '#f48024', '#69d2e7'
            ],
      },
      series: [{
            data: []
          }],
    };
  },
  props: {
    barChartData: {
      type: Array,
      default: () => [],
    },
    barChartFreq: {
      type: Array,
      default: () => [],
    },
    barChartSub: {
      type: Array,
      default: () => [],
    },
    barChartSubTitle: {
      type: Array,
      default: () => [],
    },
    barChartColor: {
      type: Array,
      default: () => [],
    },
    barChartCategory: {
      type: Array,
      default: () => [],
    },
    totalFreq: {
      type: Number,
      default: 0
    },
    isChartInit: {
      type: Boolean,
      default: false,
    },
    selectedNode: {
      type: String,
      default: '',
    },
    whichChart: {
      type: String,
      default: '',
    },
    barLoadEnd: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    whichChart() {
      this.deselect();
    },
    barLoadEnd() {
      console.log('-- barLoadEnd --')
      console.log(this.barLoadEnd)
      if(this.barLoadEnd){
        const newData = []
        for (const data of this.barChartData) {
          newData.push(data);
        }
        const newFreq = []
        for (const data of this.barChartFreq) {
          newFreq.push(data);
        }
        const newSub = []
        for (const data of this.barChartSub) {
          newSub.push(data);
        }
        const set = new Set(newSub)
        const uniqSub = [...set]

        const newSubTitle = []
        for (const data of this.barChartSubTitle) {
          newSubTitle.push(data);
        }

        const newColor = []
        for (const data of this.barChartColor) {
          newColor.push(data);
        }

        const setTitle = new Set(newSubTitle)
        const uniqSubTitle = [...setTitle]

        const newCategory = []
        for (const data of this.barChartCategory) {
          newCategory.push(data);          
        }

        // this.setHeight(45*this.barChartCategory.length)
        // this.setValues(this.barChartData, this.barChartCategory, this.totalFreq, this.barChartFreq, this.barChartSub, this.barChartSub, this.barChartSubTitle, this.barChartSubTitle, this.barChartColor)
        this.setHeight(45*newCategory.length)
        this.setValues(newData, newCategory, this.totalFreq, newFreq, newSub, uniqSub, newSubTitle, uniqSubTitle, newColor)
      }
    },
  },

  methods:{
    setHeight(value) {
      this.barChartHeight = value
    },

    deselect(){
      this.$refs.brandpinChartBar.chart.w.globals.selectedDataPoints = []
    },


    setValues(newData, newCategory, totalFreq, newFreq, newSub, uniqSub, newSubTitle, uniqSubTitle, newColor){
      console.log('@@ setValues @@')
      console.log('newData : ', newData)
      console.log('newCategory : ', newCategory)
      console.log('newFreq : ', newFreq)
      console.log('newSubTitle : ', newSubTitle)
      console.log('newColor : ', newColor)
      if (!this.isChartInit) {
        const chartOptionsBar = {
          noData: {
            text: '분석중...',
            style: {
              color: '#1817E7',
            }
          },
        };

        this.$refs.brandpinChartBar.updateOptions(chartOptionsBar, true);

        return;
      } 

      console.log('@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@')

      if (newData.length > 0) {  
        this.chartOptionsBar.xaxis = {
            categories: newCategory,
          }
        this.series = [{
            data: newData,
          }]      
        this.chartOptionsBar.tooltip = {
          shared: true,
          followCursor: true,
          intersect: false,
          x: {
            formatter(val, opt){
              return newSubTitle[opt.dataPointIndex] + ' > ' + val
              // if(newSubTitle[opt.dataPointIndex] == '라인 브랜드'){
              //   return '라인 브랜드 > ' + newSub[opt.dataPointIndex] + ' > ' + val
              // }else if(newSubTitle[opt.dataPointIndex] == 'product'){
              //   return '상품명 > ' + newSub[opt.dataPointIndex] + ' > ' + val
              // }else{
              //   return '광고/인물 > ' + newSub[opt.dataPointIndex] + ' > ' + val
              // }
              // return newSub[opt.dataPointIndex] + ' : ' + val
            }
          },
          y: {
            formatter(val, opt){
              return Math.round(newFreq[opt.dataPointIndex]).toLocaleString()
            },
            title: {
              formatter: function () {
                return ''
              }
            },
          },
        }

        this.chartOptionsBar.colors = [
          function({ value, dataPointIndex }) {
            return newColor[dataPointIndex]
          }
        ]

        this.$refs.brandpinChartBar.updateOptions(this.chartOptionsBar, true);
        
      }else{
        this.chartOptionsBar.xaxis = {
            categories: newCategory,
          }
        this.series = [{
            data: newData
          }]
        const chartOptionsBar = {
          noData: {
            text: '해당하는 키워드가 없습니다.',
            style: {
              color: '#FF009C',
            }
          },
        };
        this.$refs.brandpinChartBar.updateOptions(chartOptionsBar, true);
      }


      

      


    }
  }
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/chart-apex.scss";
</style>
